import React, { Component } from 'react';
import './App.css';

const regex = /(\+|\.|\-|\/|\*)/;
const opRegex = /(\+|\-|\/|\*)/;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      equation: "",
      currentVal: "0",
      equated: false
    };
    this.intake = this.intake.bind(this);
    this.clear = this.clear.bind(this);
    this.evaluate = this.evaluate.bind(this);
  }
  
    intake(event) {
    let temp = event.target.value;
    let newEq = this.state.equation;
    let prevVal = this.state.currentVal;
    let newVal = this.state.currentVal;
      let equated = this.state.equated;

	       if (regex.test(temp)) {
      if (newEq.charAt(0) == "" && temp != ".") {
        return;
      }
      else if (temp==".") {
        console.log(prevVal);
        if(prevVal.includes(".")) {
          return;
        }
        else {
          if (regex.test(prevVal)) {
            newVal = temp;
        newEq += temp;
        this.setState({
      ...this.state,
      equation: newEq,
          currentVal: newVal,
		  equated: false
    });
          }
          else {
            newVal += temp;
        newEq += temp;
        this.setState({
      ...this.state,
      equation: newEq,
          currentVal: newVal,
		  equated: false
    });
          }
            
        }
             
               }
      else {
        if (opRegex.test(prevVal) && temp != '-') {
          if (prevVal == '-') {
            newEq = newEq.slice(0,newEq.length - 2) + temp;
          }
          else {
            newEq = newEq.slice(0,newEq.length - 1) + temp;
          }
          newVal = temp;
          
          this.setState({
      ...this.state,
      equation: newEq,
          currentVal: temp,
		  equated: false
    });
        }
        
        else {
          newVal = temp;
        newEq += temp;
        this.setState({
      ...this.state,
      equation: newEq,
          currentVal: temp,
		  equated: false
    });
        }
      }
    }
      
    else {
		if(equated) {
			newVal = temp;
      newEq = temp;
      this.setState({
      ...this.state,
      equation: newEq,
          currentVal: newVal,
		  equated: false
    });
		}
		else 
      {if(temp=="0" && newEq.charAt(0) == "0" && newEq.length != 0) {
              return;
              }
      
      if (newEq.charAt(0) == "") {
        newVal = temp;
      newEq = temp;
      this.setState({
      ...this.state,
      equation: newEq,
          currentVal: newVal
    });
      }
      else {
        let temp3 = prevVal.charAt(prevVal.length-1);
        if (regex.test(temp3) && temp3 != ".") {
          
        newVal = temp;
      newEq += temp;
      this.setState({
      ...this.state,
      equation: newEq,
          currentVal: newVal
    });
      }
        else if (prevVal == ".") {
          newVal += temp;
      newEq += temp;
      this.setState({
      ...this.state,
      equation: newEq,
          currentVal: newVal
    });
        }
        else {
          newVal += temp;
      newEq += temp;
      this.setState({
      ...this.state,
      equation: newEq,
          currentVal: newVal
    });
        }
        
      }}
      
    }
    
  }
  
  clear() {
    let temp = " ";
    this.setState({
      ...this.state,
      equation: temp,
      currentVal: 0,
      equated: false
    });
  }
  
  evaluate() {
    if (!regex.test(this.state.equation)) {
      let temp1 = eval(this.state.currentVal);

      if(!Number.isInteger(temp1)) {
        temp1 = parseFloat(temp1.toFixed(4));
     }

     temp1 = temp1.toString();

      this.setState({
      ...this.state,
      equation: temp1,
        currentVal: temp1,
        equated: true
    });
    }
    else {
      let temp2 = eval(this.state.equation);
      
      // temp2 = Math.round((temp2 + .00001) * 100) / 100;

      if(!Number.isInteger(temp2)) {
        temp2 = parseFloat(temp2.toFixed(4));
     }

      temp2 = temp2.toString();

    this.setState({
      ...this.state,
      equation: temp2,
      currentVal: temp2,
      equated: true
    });
    }
    
  }

  render() {
    return (
    <div>
        <h1 className="headline">JavaScript Calculator, Powered by React</h1>
        <p class="credit">Created by <a href="http://patrickvhessman.com/" target="_blank">Patrick Hessman</a></p>
          <div id="calculator">
<div id="displayContainer">
  <div id="displayEquation">
  {this.state.equation}
  </div>
      <div id="display">
        {this.state.currentVal}
  </div>
            </div>
<input type="button" onClick={this.intake} id="add" class="button operator" value="+" />
	<input type="button" onClick={this.intake} id="subtract" value="-" class="button operator" />
	<input type="button" onClick={this.intake} id="multiply" value="*" class="button operator" />
	<input type="button" onClick={this.intake} id="divide" value="/" class="button operator" />
	<input type="button" onClick={this.clear} id="clear" value="C" class="button operator" />
	<input type="button" onClick={this.evaluate} id="equals" value="=" class="button" />
	<input type="button" onClick={this.intake} id="zero" value="0" class="button number" />
	<input type="button" onClick={this.intake} id="one" value="1" class="button number" />
	<input type="button" onClick={this.intake} id="two" value="2" class="button number" />
	<input type="button" onClick={this.intake} id="three" value="3" class="button number" />
	<input type="button" onClick={this.intake} id="four" value="4" class="button number" />
	<input type="button" onClick={this.intake} id="five" value="5" class="button number" />
	<input type="button" onClick={this.intake} id="six" value="6" class="button number" />
	<input type="button" onClick={this.intake} id="seven" value="7" class="button number" />
	<input type="button" onClick={this.intake} id="eight" value="8" class="button number" />
	<input type="button" onClick={this.intake} id="nine" value="9" class="button number" />
	<input type="button" onClick={this.intake} id="decimal" value="." class="button number" />
</div>
        
        </div>
    );
  }
}

export default App;
